"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _LoadingScreen = _interopRequireDefault(require("../../02_molecules/LoadingScreen"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LogginInPageUI = function LogginInPageUI(_ref) {
  var translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('LogginInPageUI');
  return /*#__PURE__*/_react["default"].createElement(_LoadingScreen["default"], {
    text: t('Signing you in')
  });
};

var _default = LogginInPageUI;
exports["default"] = _default;